import { render, staticRenderFns } from "./QueryPolicyMotorRisk.vue?vue&type=template&id=2df5fd2c&"
import script from "./QueryPolicyMotorRisk.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyMotorRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports